// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2xGHM","col":"styles_col__2jgt3"};